import { IGetRegion } from './types';
import instance from 'api/instance';

export const getRegions: IGetRegion = () => instance.get('public/regions');
